var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 720 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3711 471.978L23.0711 27.8809H13.8555L31.1554 471.978H40.3711Z",
    fill: "#7C8594"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.233 471.978L216.933 27.8809H207.693L224.993 471.978H234.233Z",
    fill: "#7C8594"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M427.315 471.977L431.44 27.9274L422.224 27.4766L418.1 471.977H427.315Z",
    fill: "#7C8594"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M617.095 471.971L620.041 27.8976L610.825 27.4941L607.855 471.971H617.095Z",
    fill: "#7C8594"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86528 97.5566H637.672V106.857H0L3.86528 97.5566Z",
    fill: "#7C8594"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86528 190.49H637.672V199.767H0L3.86528 190.49Z",
    fill: "#7C8594"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86528 278.754H637.672V288.054H0L3.86528 278.754Z",
    fill: "#7C8594"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72871 371.686H641.535V380.962H3.86328L7.72871 371.686Z",
    fill: "#7C8594"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.24 18.5703H92.3223V97.5531H189.24V18.5703Z",
    fill: "#7C8594"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M313.852 9.29297H230.77V97.5762H313.852V9.29297Z",
    fill: "#7C8594"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M396.933 27.8809H323.09V97.5631H396.933V27.8809Z",
    fill: "#7C8594"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M323.09 190.49H240.008V278.773H323.09V190.49Z",
    fill: "#7C8594"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M406.148 209.076H332.305V278.758H406.148V209.076Z",
    fill: "#7C8594"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.635 190.49H41.5527V278.773H124.635V190.49Z",
    fill: "#7C8594"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M207.695 209.076H133.852V278.758H207.695V209.076Z",
    fill: "#7C8594"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M318.471 283.406H235.389V371.689H318.471V283.406Z",
    fill: "#7C8594"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M507.685 213.717H433.842V283.399H507.685V213.717Z",
    fill: "#7C8594"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M207.695 301.979H133.852V371.661H207.695V301.979Z",
    fill: "#7C8594"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M115.396 301.979H41.5527V371.661H115.396V301.979Z",
    fill: "#7C8594"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M216.933 418.143H143.09V472H216.933V418.143Z",
    fill: "#7C8594"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M124.613 418.143H50.7695V472H124.613V418.143Z",
    fill: "#7C8594"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M410.769 413.492H336.926V471.976H410.769V413.492Z",
    fill: "#7C8594"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M532.624 385.613H429.248V471.975H532.624V385.613Z",
    fill: "#7C8594"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M720.001 390.264H627.703V471.999H720.001V390.264Z",
    fill: "#7C8594"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M318.47 413.492H244.627V471.976H318.47V413.492Z",
    fill: "#7C8594"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M544.618 0H433.842V97.5599H544.618V0Z",
    fill: "#7C8594"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStorage);
export default __webpack_public_path__ + "static/media/empty-storage.d2899570bfb8bf773ff889e72eb37de4.svg";
export { ForwardRef as ReactComponent };